(() => {
  if (window.__nllCardCartReady) return;
  window.__nllCardCartReady=true;
  document.addEventListener('submit', async (event) => {
    const form=event.target.closest('.nll-card-buy-form');
    if (!form) return;
    event.preventDefault();
    const button=form.querySelector('button');
    const error=form.querySelector('.nll-card-error');
    button.disabled=true; button.textContent='Aggiungo…'; error.hidden=true;
    try {
      const url=(window.Shopify?.routes?.root || '/')+'cart/add.js';
      const response=await fetch(url,{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Non è stato possibile aggiungere il prodotto.');
      window.location.assign(form.dataset.cartUrl || '/cart');
    } catch (e) {
      error.textContent=e.message; error.hidden=false;
      button.disabled=false; button.textContent='Acquista ora';
    }
  });
})();